import React from "react";
import AuthForm from "../../components/AuthForm/AuthForm";
const AuthPage = () => {
    return (
        <div>
            <AuthForm />
        </div>
    );
};

export default AuthPage;
